import alertsClient from "../scripts/services/alertsClient.js";
import leadsClient from "../scripts/services/leadsClient.js";
import procurementClient from "../scripts/services/procurementClient.js";
import carMatchUsedClient from "../scripts/services/carMatchUsedClient.js";
import servicesClient from "../scripts/services/servicesClient.js";

alertsClient.CountAlerts()
  .then(countResult => document.getElementById("alertBadge").textContent = countResult);



leadsClient.GetStats("", null, null)
  .then(countResult => {
    const messagesUnread = document.getElementById("messages-unread");
    if (messagesUnread) {
      if (countResult.Unread !== 0) {
        messagesUnread.textContent = countResult.Unread;
      } else {
        messagesUnread.style.display = "none";
      }
    }
  });

const procurementUnread = document.getElementById("procurement-requests-unread");

if (procurementUnread) {

  Promise.all([
    servicesClient.GetProcurementService(),
    servicesClient.GetCarMatchUsedService()
  ]).then((values) => {
    let procurementServiceActive = values[0] && values[0].IsActive;
    let carMatchUsedServiceActive = values[1] && values[1].IsActive;

    if (procurementServiceActive) {
      procurementClient.SearchProcurementRequests(1000, 1, null, null, null, 0)
        .then(countResult => {
          if (countResult.Total > 0) {
            const totalUnread = countResult.Items.filter(item => !item.ReadDate).length;
            if (totalUnread > 0) {
              procurementUnread.textContent = totalUnread;
            } else {
              procurementUnread.style.display = "none";
            }
          }
        });
    }

    else if (carMatchUsedServiceActive) {
      carMatchUsedClient.SearchCarMatchUsedRequests(1000, 1, null, null, null, 1)
        .then(countResult => {
          if (countResult.Total > 0) {
            const totalUnread = countResult.Items.filter(item => !item.ReadDate).length;
            if (totalUnread > 0) {
              procurementUnread.textContent = totalUnread;
            } else {
              procurementUnread.style.display = "none";
            }
          }
        });

    }
  });


  // Promise.all([
  //   procurementClient.SearchProcurementRequests(1000, 1, null, null, null, 0),
  //   carMatchUsedClient.SearchCarMatchUsedRequests(1000, 1, null, null, null, 0)
  // ]).then(([procurementCountResult, carMatchCountResult]) => {
  //   var totalUnread = 0;

  //   if (carMatchCountResult && carMatchCountResult.Total > 0) {
  //     totalUnread += carMatchCountResult.Items.filter(item => !item.ReadDate).length;
  //   }

  //   if (procurementCountResult && procurementCountResult.Total > 0) {
  //     totalUnread += procurementCountResult.Items.filter(item => !item.ReadDate).length;
  //   }

  //   if (totalUnread > 0) {
  //     procurementUnread.textContent = totalUnread;
  //   } else {
  //     procurementUnread.style.display = "none";
  //   }
  // }).catch(error => {
  //   console.error('Error fetching procurement or car match requests:', error);
  // });
}

